module.exports = __webpack_public_path__ + "static/media/AU Research Roster.9005cbe3.csv";